import { useState } from 'react'
import { Organization } from 'lib/types'
import { MappedIn } from 'lib/types/mappedIn'

import Step0Intro from './steps/Step0Intro'
import Step1Auth from './steps/Step1Auth'
import Step2MatchFloors from './steps/Step2MatchFloors'
import Step3MatchSpaces from './steps/Step3MatchSpaces'
import Step4MatchPOIs from './steps/Step4MatchPOIs'
import Step5SaveData from './steps/Step5SaveData'

type Props = {
  onClose: () => void
  org: Organization | null
  mappedIn: MappedIn | null
}

type WizardData = {
  org?: Organization | null
  matchedFloors?: any
  matchedSpaces?: any
  matchedPOIs?: any
  spaceMap?: any
}

export default function MappedInWizard({ onClose, org, mappedIn }: Props) {
  const [step, setStep] = useState(0)
  const [wizardData, setWizardData] = useState<WizardData>({})

  const updateDataAndNext = (newData: Partial<WizardData>) => {
    setWizardData(prev => ({ ...prev, ...newData }))
    setStep(prev => prev + 1)
  }

  const goBack = () => {
    setStep(prev => Math.max(prev - 1, 0))
  }

  const steps = [
    <Step0Intro key="step-0" onNext={() => setStep(1)} />,
    <Step1Auth key="step-1" onNext={updateDataAndNext} goBack={goBack} data={{ org }} />,
    <Step2MatchFloors
      key="step-2"
      data={{ org }}
      onNext={data => updateDataAndNext({ matchedFloors: data.matchedFloors })}
      goBack={goBack}
    />,
    <Step3MatchSpaces
      key="step-3"
      data={{
        org,
        matchedFloors: wizardData.matchedFloors ?? {},
      }}
      onNext={data => updateDataAndNext({ matchedSpaces: data.matchedSpaces })}
      goBack={goBack}
    />,
    <Step4MatchPOIs
      key="step-4"
      data={{
        org,
        matchedSpaces: wizardData.matchedSpaces,
        matchedFloors: wizardData.matchedFloors,
      }}
      onNext={data => updateDataAndNext({ matchedPOIs: data.matchedPOIs, spaceMap: data.spaceMap })}
      goBack={goBack}
    />,
    <Step5SaveData
      key="step-5"
      data={{
        org,
        matchedFloors: wizardData.matchedFloors,
        matchedSpaces: wizardData.matchedSpaces,
        matchedPOIs: wizardData.matchedPOIs,
        spaceMap: wizardData.spaceMap,
      }}
      goBack={goBack}
      onClose={onClose}
    />,
  ]

  return (
    <div style={{ padding: '1rem' }}>
      <h1 style={{ marginBottom: '1rem' }}>MappedIn Wizard</h1>
      {steps[step] ?? <p>Invalid step</p>}
    </div>
  )
}
